import { Request } from '../utils';
import { cancelTokenSource } from '../utils/axios';

const prefix = 'profile';

/* *** GET Profile Detail *** */
export const getProfileDetail = () => {
  return Request.get(`${prefix}`, { onlyError: true });
};

// *** POST Update profile detail ***
export const updateProfile = values => {
  return Request.post(`${prefix}`, values, {
    cancelToken: cancelTokenSource.token,
    handleNotification: true
  });
};

// *** DELETE Profile Photo
export const deleteProfilePhoto = () => {
  return Request.delete(`${prefix}/photo`, { onlyError: true });
};

/* ----  update password ------ */
export const updateUserPassword = values => {
  const { password, password_confirmation } = values;
  const valueToUse = {
    password: password.trim(),
    password_confirmation: password_confirmation.trim()
  };

  return Request.put(`${prefix}/password`, valueToUse, { handleNotification: true });
};
